/**
 * CookieUtil - handle date formatting in [largely] the same fashion as PHP.
 * Quirks:
 * Time Zones: Since php uses server time and js uses client time, these will often not line up.
 * 'e' [Timezone formatting] will return the same value as 'P'.  This is because the browser does not have access to the IANA timezone database, so it cannot return the timezone name.
 * 'p' [Timezone formatting] _should_ work, but requires the users's clock to be set to GMT to return the value of 'Z'
 * 'X'/'x' [Year formatting] are not great. They are not exactly the same as PHP's 'X'/'x', but they are similar.  I don't recommend them, and they are likely to be needed anyway.
 */
const CookieUtil = {};

// Helpers

/**
 * Get the cookie for a given name
 * @param {string} name - The name of the cookie to get
 * @returns {string|null} - The value of the cookie, or null if not found
 */
CookieUtil.getCookie = function (name) {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) {
		let result = parts.pop().split(';').shift();
		return result;
	}
	return null;
};

/**
 * Set the cookie for a given name
 * @param {string} name - The name of the cookie to set
 * @param {string} value - The value of the cookie
 * @param {number} days - The number of days until the cookie expires
 */
CookieUtil.setCookie = function (name, value, days = 365) {
	const expires = new Date(Date.now() + (days * 864e5)).toUTCString(); // 864e5 = 1 day in ms
	document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
};

module.exports = CookieUtil;